import { render } from "./CatalogViewer.vue?vue&type=template&id=77251264"
import script from "./CatalogViewer.vue?vue&type=script&lang=js"
export * from "./CatalogViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__